import { BlogSection } from '@/types/blog';

export const rechtlicherHinweisSection: BlogSection = {
  id: 'rechtlicher-hinweis',
  title: '',
  content: `
    <div class="my-10 p-5 rounded-lg bg-muted/30 border border-muted flex items-start gap-3">
      <span class="text-muted-foreground mt-0.5 flex-shrink-0">ℹ️</span>
      <p class="text-sm text-muted-foreground leading-relaxed">
        Rechtlicher Hinweis: Meine Tätigkeit umfasst ausschließlich Coaching und prozessbegleitende Beratung. 
        Es erfolgt keine Vermittlung von Finanz- oder Versicherungsprodukten, keine Anlageberatung zu konkreten 
        Finanzinstrumenten (z.&nbsp;B. ISIN/WKN), keine Rechts- oder Steuerberatung und keine Ausübung von 
        Heilkunde im Sinne der klinischen Psychotherapie oder Psychologie. Die berücksichtigten Erkenntnisse 
        der Finanzpsychologie dienen der persönlichen Weiterentwicklung und Selbstregulation.
      </p>
    </div>
  `
};
